<template>
	<div>
		<el-card :shadow="fromType === 4 ? 'never' : 'always'">
			<div v-if="getFormConfig && fromType !== 4" slot="header">
				<span v-html="clearPLabel(getFormConfig.label)"></span>
				<el-tooltip
					v-if="sameUnitData && sameUnitData.visible === 1 && fromType !== 3"
					:content="
						sameUnitData.options
							? sameUnitData.options[0].popover || '被保企业和投保企业为同一企业'
							: '保司要求投保企业与被保企业必须为同一单位！'
					"
					:disabled="sameUnitData.disabled !== 2"
					effect="light"
					placement="top">
					<el-checkbox
						v-model="unitFormData.same"
						:disabled="sameUnitData.disabled !== 2"
						style="float: right; padding: 4px 0"
						@change="onSameUnitChange">
						{{ sameUnitData.options ? sameUnitData.options[0].label : '被保企业同投保企业' }}
					</el-checkbox>
				</el-tooltip>
			</div>
			<el-alert
				v-if="isShowAlert && fromType !== 4"
				:title="isShowAlert"
				show-icon
				style="margin-bottom: 10px"
				type="warning"></el-alert>
			<avue-form
				ref="refUnitForm"
				v-model="unitFormData"
				v-loading="isLoading"
				:option="unitOption"
				:upload-after="uploadAfter"
				:upload-before="onUploadBefore"
				@submit="onSubmitUnit">
				<el-autocomplete
					v-if="!isRenBao(insureType)"
					ref="refUnitName"
					slot="name"
					v-model="unitFormData.name"
					:debounce="300"
					:disabled="!unitOption.submitBtn"
					:fetch-suggestions="querySearch"
					:trigger-on-focus="true"
					clearable
					placeholder="请填写 企业名称"
					style="width: 100%"
					@clear="onUnitNameClear"
					@select="onChoiceUnit"></el-autocomplete>
				<template #menuForm="{}">
					<el-button v-if="!unitOption.submitBtn" icon="el-icon-edit" @click="onCheckUnitResult(false)">修改</el-button>
				</template>
			</avue-form>
		</el-card>
		<InsureNotices
			ref="refInsureNotices"
			@onToInsure="onGoInsure"
			@onToSure="onToSure"
			@onToSureEnd="onToSure"></InsureNotices>
		<DialogGetiHint ref="refGetTiHint" @onGetiSure="onGetiSure"></DialogGetiHint>

		<XsmYinLiuDialog ref="refXsmYinLiu" @onShowInsureHint="onShowInsureHint"></XsmYinLiuDialog>
	</div>
</template>

<script>
import {
	checkUnit,
	getAreaList,
	getUnitHistory,
	getUnitInfoByLicense,
	uploadIdNoImg,
} from '@/views/insuranceCenter/api/insureApiNew'
import {getBaseUnitOption, getCompleteOption, onSetLayout} from 'meibao-insure/src/option/baseOption'
import {
	getAreaCodeList,
	getInsureUnitData,
	getTermData,
	getTransIntoUnitData,
	getUnitHistoryData,
	isAbleAreaCode,
} from 'meibao-insure/src/util/unitFormUtils'
import {clearEmptyData, clearPLabel, getPageId} from 'meibao-insure/src/util/commonUtils'
import InsureNotices from 'meibao-insure/src/components/InsureNotices.vue'
import DialogGetiHint from 'meibao-insure/src/components/dialog/dialogGetiHint.vue'
import {isAnZeDianti, isRenBao, isZhongYin} from 'meibao-insure/src/util/productUtil'
import {addIdNoQuery} from 'meibao-insure/src/api/productCenterNew'
import {getImgUrl} from '@/config/env'
import XsmYinLiuDialog from 'meibao-insure/src/components/dialog/xsmYinLiuDialog.vue'
import {setStore} from '@/util/store'
import rrlog from '@meibao/traceback-record'
import {emit_plan_check} from 'meibao-insure/src/util/emitDic'

export default {
	name: 'FormUnitNew',
	components: {XsmYinLiuDialog, InsureNotices, DialogGetiHint},
	props: {
		//引用不同地方
		// 1：投保企业，2：被保企业 3：计划书 4：共同被保险人！！
		fromType: {
			required: true,
			type: Number,
			validator: (value) => {
				return [1, 2, 3, 4].includes(value)
			},
		},
		productId: {
			type: Number | String,
			required: true,
		},
		sourceProductId: {
			type: Number | String,
			required: true,
		},
		insureType: {
			type: Number | String,
			required: true,
		},
		applicantFormData: {
			type: Object,
			required: true,
			default: () => {
				return {}
			},
		},
		//金额大于多少，新增其他字段
		totalPremium: Number,
	},
	data() {
		return {
			isShowForm: false,
			unitOption: {},
			//企业数据
			unitFormData: {same: true, name: '', certNo: '', areaCode: ''},
			originData: {},
			templateData: {},
			//历史网点
			unitList: [],
			isNoYear: false,
			addIdNoInterval: null,
			rrlogEventId: null,
			yinliuChoiceData: {},
			isLoading: false,
			lastUnitFormData: null,
			//是否需要再次确认企业
			isSubAgain: false,
			//不可填写的默认值
			defaultData: {},
		}
	},
	watch: {
		//基础配置文件
		applicantFormData: {
			handler(val) {
				if (!this.validatenull(val)) {
					//请求数据传递，处理option
					this.unitOption = getCompleteOption(val, getBaseUnitOption(this.applicantFormData, this.fromType === 3))
					//处理布局！！！！！
					onSetLayout(this.unitOption)
					//额外处理option数据
					this.onDealOptionData()
					console.log('this.unitOption', this.unitOption)
					this.isShowForm = true
					//处理地区选项！
					this.getAreaList()
				}
			},
			immediate: true,
		},
		'unitFormData.areaCode': {
			handler(val) {
				if (!this.validatenull(val) && this.$refs.refUnitForm) {
					this.$refs.refUnitForm.validateField('areaCode')
				}
			},
		},
		//证件有效期
		'unitFormData.termType': {
			handler(val = '') {
				if (val) {
					//中银则不隐藏
					if (isZhongYin(this.insureType)) {
						return
					}
					let termEnd = this.findObject(this.unitOption.column, 'termEnd')
					if (termEnd) {
						if ((val === '2' && !termEnd.display) || (val !== '2' && termEnd.display)) {
							termEnd.display = val === '2'
							//重新布局
							onSetLayout(this.unitOption)
						}
					}
				}
			},
		},
		//金额和是否确定人员信息
		totalPremium(newVal = 0, oldVal = 0) {
			if (newVal > 0 && newVal !== oldVal) {
				//由于金额大于5000等，险种需要展示其他字段！！！
				this.onShowOtherProp(newVal)
			}
		},
	},
	created() {},
	computed: {
		getFormConfig() {
			if (this.validatenull(this.applicantFormData.config)) {
				return null
			}
			return this.applicantFormData.config
		},
		isShowAlert() {
			let {notice = {}} = this.getFormConfig || {}
			return notice.content || ''
		},
		//是否有被保企业同投保企业
		sameUnitData() {
			if (this.validatenull(this.applicantFormData)) {
				return false
			}
			return this.applicantFormData.same || null
		},
	},
	methods: {
		isRenBao,
		clearPLabel,
		//获取dicData
		getAreaList() {
			let areaCodeData = this.applicantFormData.areaCode
			let areaCodeOption = this.findObject(this.unitOption.column, 'areaCode')
			if (areaCodeOption !== -1 && !this.validatenull(areaCodeData)) {
				//存在
				getAreaList(3)
					.then((response) => {
						//封装处理
						areaCodeOption.dicData = getAreaCodeList(areaCodeData.verifies || [], response.data.data)
						this.$refs.refUnitForm.initDic()
					})
					.catch(() => {})
			}
		},
		querySearch(queryString = '', cb) {
			let selectOptions = []
			let query = queryString !== '' ? {unitName: queryString} : {}
			getUnitHistory(query)
				.then((response) => {
					let unitList = response.data.data || []
					//处理数据
					selectOptions = unitList.map((item) => {
						return {
							value: item.unitName,
							data: item,
						}
					})
				})
				.catch(() => {})
				.finally(() => {
					cb(selectOptions)
				})
		},
		//选择历史企业数据
		onChoiceUnit({data = {}}) {
			//处理历史企业数据
			getUnitHistoryData(this.unitFormData, data)
			//判断企业地区
			//删除不符合的
			this.isClearAreaCode()
			console.log('unitFormData------', this.unitFormData)
			this.$nextTick(() => {
				if (this.$refs.refUnitForm) {
					this.$refs.refUnitForm.clearValidate() // 只清除清除验证
				}
			})
		},
		//清空企业名称
		onUnitNameClear() {
			this.$refs.refUnitName.activated = true
			this.unitFormData.name = ''
			this.$refs.refUnitName.getData('')
		},
		//再次确认企业
		onSubmitAgain() {
			//并且企业已经确认！
			if (this.isSubAgain && !this.unitOption.submitBtn) {
				this.$refs.refUnitForm.submit()
			}
		},
		//提交企业信息
		onSubmitUnit(form, done) {
			//处理错误数据
			this.onDealErrorData()
			//处理unitFromData 的 type
			this.unitFormData.type = this.onGetUnitType()
			//获取到数据
			let tempUnitData = this.deepClone(clearEmptyData(this.unitFormData))
			//  校验网点信息
			let checkUnitData = {
				orderInfo: {
					sourceProductId: this.sourceProductId,
					productId: this.productId,
				},
			}
			//处理same
			tempUnitData.same = ''
			//区分类型
			if (this.fromType === 1 || this.fromType === 3) {
				checkUnitData.applicant = tempUnitData
			} else {
				checkUnitData.insurant = tempUnitData
			}
			this.isSubAgain = false
			console.log('checkUnitData--------', checkUnitData)
			checkUnit(checkUnitData)
				.then((res = {}) => {
					let {code = -1, originCode = '', originMsg = '', data = {}} = res.data || {}
					this.isNoYear = false
					/**
					 *  "buy24": null,
					 * "third": "0",
					 *  "insureConfirmUrl": null,
					 * "insureConfirmSample": null,
					 * "maxEffDate": null,
					 *  "taxType": null
					 */
					//结构数据
					let {params: {sourceProductId = '', productId = '', plans = []} = {}, unit: unitJiexi = ''} = data
					if (code !== 0 || (originCode !== '200' && originCode !== '0')) {
						if (originCode === '205') {
							//重新提示，重新结算保费
							this.$confirm(originMsg, '提示', {
								confirmButtonText: '确认投保地区版方案',
								cancelButtonText: '更改投保企业',
								dangerouslyUseHTMLString: true,
							})
								.then(() => {
									//替换productID,重新请求 修改数据，则需要重新计算保费
									this.$emit('onChangeProductId', {sourceProductId, productId})
									setTimeout(() => {
										this.$refs.refUnitForm.submit()
									}, 100)
								})
								.catch(() => {
									done()
								})
							return
						} else if (originCode === '210') {
							//从地区版本切换到全国，则重新计算保费
							//替换productID,重新请求保费
							this.$emit('onChangeProductId', {sourceProductId, productId, isClearArea: true})
							setTimeout(() => {
								this.$refs.refUnitForm.submit()
							}, 100)
							return
						} else if (originCode === '220') {
							//地区全国版本 不自动切换，提醒就行
							this.$alert(originMsg, '提示', {confirmButtonText: '我知道了'}).then(() => {})
							done()
							this.isSubAgain = true
							//判断方案是否确认了，如果方案确认，则取消
							this.$Bus.$emit(emit_plan_check, {errorCode: '220'})
						} else if (originCode === '499' && plans.length > 0) {
							//引流 切换险种
							//弹出引流弹窗
							this.$refs.refXsmYinLiu.showXsmInsuresHint({msgHint: originMsg, productList: plans})
							done()
							return
						} else if (!originMsg.includes('您选择的企业暂时无法投保年单')) {
							this.$alert(originMsg || '校验企业异常，无明确提示信息！', '提示', {}).then(() => {})
							//有错误，恢复按钮确定
							this.onCheckUnitResult(false)
							done()
							return
						} else {
							this.isNoYear = true
						}
					}
					//赋值
					this.originData = data
					//获取数据 如果不存在
					let isShowGeTi = false
					//解析营业执照数据
					if (unitJiexi) {
						let {result = {econKind: ''}} = JSON.parse(unitJiexi) || {}
						this.templateData = result
						if (result.econKind === '个体工商户') {
							isShowGeTi = true
						}
					}
					if (isShowGeTi && this.envConfig.isBxIe()) {
						this.$refs.refGetTiHint.showGetiHint()
					} else {
						//判断是否有提示
						let {hintInfos = []} = this.applicantFormData.config || {}
						if (hintInfos.length <= 0) {
							//投保
							this.onCheckUnitResult(true)
						} else {
							//弹出提示
							this.$refs.refInsureNotices.onShowNotices(hintInfos[0])
						}
					}
				})
				.catch((error) => {
					console.error('checkUnit----', error)
				})
				.finally(() => {
					done()
				})
		},
		//提示回调,点击确认
		onToSure() {
			this.onCheckUnitResult(true)
		},
		//个体工商户提示
		onGetiSure() {
			//确认其他提示
			//判断是否有提示
			let {hintInfos = []} = this.applicantFormData.config || {}
			if (hintInfos.length <= 0) {
				//投保
				this.onCheckUnitResult(true)
			} else {
				//弹出提示
				this.$refs.refInsureNotices.onShowNotices(hintInfos[0])
			}
		},
		//识别成功后处理 true,确认， false 取消
		onCheckUnitResult(result) {
			//如果是共同被保险人，则不需要结果了
			if (this.fromType === 4) {
				this.$emit('onSubmittedData', this.onGetSubUnitData())
				return
			}
			if (this.unitOption.submitBtn === !result) {
				//重复点击直接返回
				return
			}
			//企业名称
			this.unitOption.column.forEach((itemData) => {
				//解构
				let {prop = ''} = itemData
				if (!prop.includes('example') && !this.defaultData[prop]) {
					itemData.disabled = result
				}
			})
			this.unitOption.submitBtn = !result
			if (result) {
				this.$message.success('确认成功')
				let submitData = this.onGetSubUnitData()
				if (this.isNoYear) {
					submitData.isNoYear = true
				}
				//盖章文件只识别投保
				if (this.fromType === 1) {
					this.$Bus.$emit('taxTypeNew', submitData)
					if (isRenBao(this.insureType)) {
						//人保需要发送给投保人员
						this.$Bus.$emit('onEmitEmpData', submitData)
					}
				}
				//重新计算保费
				this.$emit('onNeedCalcPrice', true)
				//判断之前的企业和当前的企业是否一致，不一致则需要处理数据
				let isReyInitPlan = false
				if (this.lastUnitFormData) {
					let {name, certNo} = this.lastUnitFormData
					isReyInitPlan = name !== submitData.name || certNo !== submitData.certNo
				}
				//返回的数据
				this.$emit('onSubmittedData', {type: this.fromType === 1 ? 1 : 2, ...submitData, isReyInitPlan})
				//赋值last
				if (!this.lastUnitFormData || isReyInitPlan) {
					this.lastUnitFormData = submitData
				}
				// let {data: minEffDate = '', maxEffDate = ''} = this.originData
				// if (minEffDate !== '' && maxEffDate !== '') {
				//   this.$Bus.$emit('onBusEffectiveData', {minEffDate, maxEffDate})
				// }
			} else {
				//取消则清空盖章文件，以及数据
				//清空盖章文件
				this.unitFormData.statementImg = ''
				this.unitFormData.insureConfirmFile = ''
				//盖章文件只识别投保
				if (this.fromType === 1) {
					//控制专票和普票
					this.$Bus.$emit('taxTypeNew', {})
				}
			}
		},
		async uploadAfter(res, done, loading, column) {
			this.isLoading = true
			//根据URL 获取企业信息
			if (column.prop === 'certImgFront') {
				try {
					let result = (await getUnitInfoByLicense(res.url, this.sourceProductId)) || {}
					let {code = -1, msg = '解析失败！', data = {}} = result.data
					if (code !== 0) {
						throw new Error(msg)
					}
					let {name = '', address = '', regNum = '', person = ''} = data
					//校验企业信息
					this.unitFormData.addr = address
					this.unitFormData.legalPerson = person
					let {name: nameForm = '', certNo = ''} = this.unitFormData
					if ((nameForm !== '' && nameForm !== name) || (certNo !== '' && certNo !== regNum)) {
						let hintText = [
							'营业执照识别数据与填写数据不匹配！',
							'识别数据：',
							`${name}，${regNum}`,
							'填写数据：',
							`${nameForm === '' ? '空' : nameForm}，${certNo === '' ? '空' : certNo}`,
						]
						const hintTextNew = []
						const H = this.$createElement
						for (let text in hintText) {
							hintTextNew.push(H('p', null, hintText[text]))
						}
						//识别结果不同
						this.$confirm(H('div', null, hintTextNew), '提示', {
							confirmButtonText: '自动替换',
							cancelButtonText: '手动修改',
						})
							.then(() => {
								this.unitFormData.name = name
								this.unitFormData.certNo = regNum
								//重新需要校验企业信息！！！
								if (!this.isConfirm()) {
									//重新填写
									this.onCheckUnitResult(false)
								}
							})
							.catch(() => {})
					} else {
						this.unitFormData.name = name
						this.unitFormData.certNo = regNum
					}
				} catch (e) {
					this.$alert(e.message || '服务器错误，请稍后重试！', '提示').then(() => {})
				} finally {
					done()
				}
			} else {
				done()
			}
			this.isLoading = false
		},
		searchBlur(e) {
			this.unitFormData.name = e.target.value
		},
		onGetSubUnitData() {
			//处理特殊
			this.OnDealUnitDataSpecial()
			//获取提交数据
			let {name = '', certNo = '', areaCode = ''} = this.unitFormData
			if (name === '' || certNo === '' || areaCode === '') {
				return {}
			}
			let tempUnitData = this.deepClone(this.unitFormData)
			tempUnitData.same = ''
			return clearEmptyData(tempUnitData)
		},
		//设置企业现实特殊性！
		OnDealUnitDataSpecial() {
			if (isAnZeDianti(this.insureType)) {
				this.unitFormData.industry = 'E'
				this.unitFormData.category = 5
				this.unitFormData.registerCapital = '200'
			}
			//经营范围
			let tempScope = this.unitFormData.businessScope || ''
			if (tempScope !== '' && tempScope.length > 30) {
				this.unitFormData.businessScope = tempScope.substring(0, 25)
			}
			let {industry = ''} = this.unitFormData
			//如果industry有值，需要获取label
			if (industry) {
				let {dicData = []} = this.findObject(this.unitOption.column, 'industry') || {}
				let tempCategory = dicData.find(({value = ''}) => value === industry)
				if (tempCategory) {
					//加字段
					this.unitFormData.industryName = tempCategory.label
				}
			}
			//人保,并且为计划书需要加certType
			if (isRenBao(this.insureType) && this.fromType === 3) {
				this.unitFormData.certType = '100'
			}
		},
		/**
		 * 最后insure接口还是要走波哥的数据！！！！！
		 */
		getInsureUnit() {
			return getInsureUnitData(this.deepClone(this.unitFormData))
		},
		//设置参数 计划书
		onSetUnitData(tempUnitData, isFromPlan = false) {
			if (!isFromPlan) {
				//转换
				getTransIntoUnitData(this.unitFormData, tempUnitData)
			} else {
				//转换
				Object.assign(this.unitFormData, tempUnitData)
			}
			//特殊处理一下营业执照地址
			let {certImgFront = ''} = this.unitFormData
			if (certImgFront !== '') {
				this.unitFormData.certImgFront = getImgUrl(certImgFront)
			}
			//删除不符合的
			this.isClearAreaCode()
		},
		//是否清理缓存
		isClearAreaCode() {
			let {areaCode = ''} = this.unitFormData
			if (areaCode !== '') {
				let {verifies = []} = this.applicantFormData.areaCode || {}
				if (verifies.length > 1) {
					//判断当前地址不符合可投地区，则清除！！！！
					if (!isAbleAreaCode(verifies, areaCode)) {
						this.unitFormData.areaCode = ''
					}
				}
			}
			//合并数据
			Object.assign(this.unitFormData, this.defaultData)
		},
		//上传之前处理是否为人保
		async onUploadBefore(fileData, done, loading) {
			this.isLoading = true
			let {type = '', size = 0} = fileData
			console.log('onUploadBefore------', fileData)
			//人保
			if (isRenBao(this.insureType)) {
				//清理
				this.onClearInterval()
				let formData = new FormData()
				formData.append('files', fileData)
				formData.append('side', 'face')
				formData.append('idName', '')
				formData.append('batchld', '0')
				try {
					//上传身份证图片
					let retryNum = 0
					let result = (await uploadIdNoImg(formData)) || {}
					let {code = -1, data = {}} = result.data
					if (code !== 0) {
						this.isLoading = false
						return
					}
					let {batchId = -1, files = []} = data
					if (files.length > 0) {
						this.unitFormData.certImgFront = files[0].url
					}
					//循环调用获取身份证数据
					this.addIdNoInterval = setInterval(async () => {
						try {
							let resultAdd =
								(await addIdNoQuery(batchId).catch(() => {
									this.onClearInterval()
								})) || {}
							let {code: code1 = -1, data: {emps = []} = {}} = resultAdd.data
							if (code1 === 0 && emps.length > 0) {
								let {code: code2 = '', msg = '身份证解析失败！'} = emps[0]
								if (code2 === '200' || code2 === '0') {
									//成功！
									this.onClearInterval()
									//进行校验！！！
									this.onJudgeContent(emps[0])
								} else if (code2 === '400') {
									this.$message.error(msg)
									//失败
									this.onClearInterval()
								} else {
									//重试
									retryNum++
									if (retryNum >= 10) {
										//清理
										this.onClearInterval()
										this.$message.error('身份证照片识别失败！')
									}
								}
							}
						} catch (e) {
							this.onClearInterval()
							this.$message.error(e.message || '身份证照片识别失败！')
							this.isLoading = false
						}
					}, 2000)
				} catch (e) {
					this.onClearInterval()
					this.$message.error(e.message || '身份证照片识别失败！')
					this.isLoading = false
				} finally {
					loading()
				}
			} else {
				//错误提示
				let msg = ''
				if (type !== 'image/jpeg' && type !== 'image/png') {
					msg = '上传图片只支持JPEG或PNG格式!'
				} else if (size / 1024 / 1024 > 5) {
					msg = '请上传大小不超过5Mb的jpg/png文件'
				}
				if (msg) {
					this.isLoading = false
					this.$message.error(msg)
					loading()
					return
				}
				done()
			}
		},
		//清理循环查询
		onClearInterval() {
			if (this.addIdNoInterval) {
				clearInterval(this.addIdNoInterval)
				this.addIdNoInterval = null
				this.isLoading = false
			}
		},
		onJudgeContent(queryIdNoData) {
			let {idno = '', name = '', address: address1 = ''} = queryIdNoData
			let {certNo = '', name: name1 = ''} = this.unitFormData
			if (certNo !== '' || name1 !== '') {
				if (idno !== certNo || name !== name1) {
					let hintText = [
						'身份证识别数据与填写数据不匹配！',
						`识别数据：${name}，${idno}`,
						`填写数据：${name1 === '' ? '空' : name1}，${certNo === '' ? '空' : certNo}`,
					]
					const hintTextNew = []
					const H = this.$createElement
					for (let text in hintText) {
						hintTextNew.push(H('p', null, hintText[text]))
					}
					//识别结果不同
					this.$confirm(H('div', null, hintTextNew), '提示', {
						confirmButtonText: '自动替换',
						cancelButtonText: '手动修改',
					})
						.then(() => {
							this.unitFormData.name = name
							this.unitFormData.certNo = idno
							this.unitFormData.addr = address1
						})
						.catch(() => {})
				}
			} else {
				this.unitFormData.name = name
				this.unitFormData.certNo = idno
				this.unitFormData.addr = address1
				//地区身份证前六位
				if (idno.length > 6) {
					this.unitFormData.areaCode = idno.substring(0, 6)
				}
			}
		},
		//改变被保投保信息
		onSameUnitChange() {
			this.$emit('onSameUnitChange', this.unitFormData.same)
			this.onCheckUnitResult(false)
		},
		onClearOtherData(tempPlanData) {
			//删除空数据
			for (let tempPlanDataKey in tempPlanData) {
				if (tempPlanDataKey.includes('$')) {
					delete tempPlanData[tempPlanDataKey]
				}
			}
		},
		//是否确定
		isConfirm() {
			return this.unitOption.submitBtn
		},
		//由于金额大于5000等，险种需要展示其他字段！！！
		onShowOtherProp() {
			//处理安责金额控制其他字段！！！！
			//人员确定，以及出现过金额大于5000的时候 才触发
			let isChanged = false
			let isNeedInput = false
			this.unitOption.column.forEach((itemData) => {
				let {prop = '', display = false} = itemData
				let {visibleConditions = []} = this.applicantFormData[prop] || {}

				if (visibleConditions.length > 0) {
					let {value = '0'} = visibleConditions[0]
					if (!display && this.totalPremium >= parseInt(value)) {
						//大于
						//处理数据把获取的数据自动填写
						let {registerCapital = '', businessScope = '', termType = ''} = this.unitFormData
						if (!this.validatenull(this.templateData) && this.validatenull(businessScope)) {
							let {registCapi = '', termStart = '', termEnd = '', scope = ''} = this.templateData
							//先判断
							try {
								this.unitFormData.termStart = getTermData(termStart)
								this.unitFormData.termEnd = getTermData(termEnd)
							} catch (e) {
								this.unitFormData.termStart = ''
								this.unitFormData.termEnd = ''
							}
							this.unitFormData.termType = termEnd !== '' && termEnd === '-' ? '1' : '2'
							this.unitFormData.businessScope = scope.length > 30 ? scope.substring(0, 25) : scope
							if (this.validatenull(registerCapital)) {
								if (registCapi !== '') {
									registCapi = registCapi.replace(/[^0-9.]/gi, '')
								}
								if (!this.validatenull(registCapi)) {
									this.unitFormData.registerCapital = registCapi
								}
							}
						}
						//未显示，并且大于固定金额，则显示
						//如果是证件有效期终止，则需要判断是否有证件有效期类型
						if (prop !== 'termEnd' || (prop === 'termEnd' && termType !== '1')) {
							itemData.display = true
							isChanged = true
							if (this.validatenull(this.unitFormData[prop])) {
								isNeedInput = true
							}
						}
					} else if (display && this.totalPremium < parseInt(value)) {
						//已显示，并且小于固定金额，则隐藏
						itemData.display = false
						isChanged = true
					}
				}
			})
			if (isChanged) {
				//更改过显隐，则重新布局
				//处理布局！！！！！
				onSetLayout(this.unitOption)
			}
			if (isNeedInput) {
				//需要填写
				//数据为空，则需要滚动到上面填写
				this.$alert('根据规定：需要上传其他投保企业信息', '提示', {
					type: 'warning',
					confirmButtonText: '知道了',
				}).then(() => {
					//重新填写
					if (!this.isConfirm()) {
						this.onCheckUnitResult(false)
					}
					//回到顶部
					this.$emit('onGoToTop')
				})
			}
		},
		//引流弹投保窗口
		async onShowInsureHint(choiceData = {}) {
			let {sourceProductId, productId, memo = ''} = choiceData
			if (this.fromType === 3) {
				//如果是计划书则直接返回数据，跳转计划书就行
				this.$emit('onToChangeInsure', choiceData)
				return
			}
			this.yinliuChoiceData = choiceData
			this.rrlogEventId = rrlog.capture(
				`去投保`,
				{
					productId: sourceProductId,
					productName: memo,
				},
				{
					sign: true,
				},
			)
			//获取投保提示信息
			await this.$refs.refInsureNotices.onGetHintInfoData({productId, sourceProductId})
		},
		onGoInsure() {
			let pageId = getPageId()
			if (this.rrlogEventId) {
				setStore({name: `rrlog_eventid_${pageId}`, content: this.rrlogEventId, type: 'session'})
			}
			this.yinliuChoiceData.pageId = pageId
			this.yinliuChoiceData.isYinliu = true

			this.$emit('onToChangeInsure', this.yinliuChoiceData)
		},
		// fromType 1：投保企业，2：被保企业 3：计划书 4：共同被保险人！！
		onGetUnitType() {
			/* insureConfirmFile:上传的投保人申请地址
       type：网点类型
       0--投保人、被保人
       1--投保人
       2--被保人
       3--共同被保人
       * */

			switch (this.fromType) {
				case 4:
					return '3'
				case 2:
					return '2'
				default:
					//团意险，不存在被保企业同投保企业
					if (!this.sameUnitData) {
						return '1'
					}
					return this.unitFormData.same ? '0' : '1'
			}
		},
		//清空数据
		onRecycleData() {
			//清空数据
			if (this.$refs.refUnitForm) {
				this.$refs.refUnitForm.resetForm()
				// this.unitOption.column[this.unitOption.column.l]
				this.unitFormData.example1 = 'https://qtbx.meibaokeji.com.cn/employer/static/2022images/yyzz.png'
			}
		},
		onDealErrorData() {
			let {certImgFront = ''} = this.unitFormData
			if (certImgFront && certImgFront.includes(',')) {
				this.unitFormData.certImgFront = certImgFront.split(',')[0]
			}
		},
		//计划书进入，需处理option
		onDealOptionData() {
			this.unitOption.column.forEach((item) => {
				let {prop = '', value = '', display = false, disabled = false} = item
				//如果是计划书还得处理营业执照非必填
				if (this.fromType === 3) {
					if (prop === 'certImgFront') {
						item.label = !isRenBao(this.insureType) ? '营业执照(选填)' : '身份证(选填)'
						item.rules = []
					}
					if (value) {
						this.unitFormData[prop] = value
					}
				}
				//如果为合康，则初始化数据
				// if (this.envConfig.isBxMeidiGuangfu()) {
				// 	if (value) {
				// 		this.unitFormData[prop] = value
				// 	}
				// }
				if (value && display && !prop.includes('example')) {
					this.$set(this.unitFormData, prop, value)
				}
				//营业执照时间判断
				if (prop === 'termEnd' && display) {
					this.onAddTermEndRules(item.rules || [])
				}
				//判断是否为不可选择的数据
				if (disabled && value && !prop.includes('example')) {
					this.defaultData[prop] = value
				}
			})
		},
		//添加营业执照起期和止期的判断
		onAddTermEndRules(rules) {
			rules.push({
				validator: (rule, value, callback) => {
					let {termStart = ''} = this.unitFormData
					if (termStart && value && new Date(value).getTime() < new Date(termStart).getTime()) {
						callback(new Error('营业执照止期不能早于营业执照起期'))
					} else {
						callback()
					}
				},
				trigger: ['blur', 'change'],
			})
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger {
	width: 150px;
	border: transparent;
}

::v-deep .el-card__body {
	padding: 20px 20px 0 20px;
}
</style>
